import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import DynamicProvider from "@thrivecoin/authentication-v2";
import { AuthenticationProvider } from "./AuthenticationProvider";
import queryClient from "@/lib/reactQuery";
import WhiskSdkProvider from "./WhiskSdkProvider";
import { Toaster } from "@/ui/Toast/Toaster";
import FarcasterProvider from "./FarcasterProvider";
import { signInParamsFN } from "@/lib/providerConfigs";
import { ConsentProvider } from "./ConsentProvider";
import { HelmetProvider } from "react-helmet-async";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryFallback } from "@/components/ErrorBoundary";
import GlobalLoaderProvider from "./GlobalLoaderProvider";

function MainProvider({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      <FarcasterProvider>
        <WhiskSdkProvider>
          <HelmetProvider>
            <GlobalLoaderProvider>
              <DynamicProvider
                config={{ environmentId: import.meta.env.VITE_DYNAMIC_ENVIRONMENT_ID }}
                apiUrl={import.meta.env.VITE_API_BASE_URL + "/v1"}
                signInParamsFN={signInParamsFN}
                websocketUrl={import.meta.env.VITE_WEBSOCKET_SERVER_URL}
              >
                <QueryClientProvider client={queryClient}>
                  <ReactQueryDevtools initialIsOpen={false} position="right" buttonPosition="bottom-right" />
                  <ConsentProvider>
                    <AuthenticationProvider>
                      <Toaster />
                      {children}
                    </AuthenticationProvider>
                  </ConsentProvider>
                </QueryClientProvider>
              </DynamicProvider>
            </GlobalLoaderProvider>
          </HelmetProvider>
        </WhiskSdkProvider>
      </FarcasterProvider>
    </ErrorBoundary>
  );
}

export default MainProvider;
